export enum ImageTabs {
  MARKETER = 'MARKETER',
  ARTICLE = 'ARTICLE'
}
